import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { PopulateAddressPropertyInfoFromEpcMutation } from '@/gql/graphql';

const POPULATE_ADDRESS_PROPERTY_INFO_FROM_EPC_MUTATION = graphql(`
  mutation PopulateAddressPropertyInfoFromEpc(
    $input: PopulateAddressPropertyInfoFromEpcInput!
  ) {
    populateAddressPropertyInfoFromEpc(input: $input)
  }
`);

const usePopulateAddressPropertyInfoFromEpc = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    PopulateAddressPropertyInfoFromEpcMutation,
    unknown,
    { addressId: string }
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: { addressId: string }) => {
      return gqlClient.request(
        POPULATE_ADDRESS_PROPERTY_INFO_FROM_EPC_MUTATION,
        { input }
      );
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.spruceProjectData(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default usePopulateAddressPropertyInfoFromEpc;
